var _rect, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEditNew = function SvgIconEditNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 45,
    rx: 3.5,
    fill: "#FAFAFA",
    stroke: "#B1ACAC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0564 14.3438L11.7508 28.6654C11.6789 28.7376 11.6269 28.8289 11.6022 28.9269L10.0165 35.298C9.96909 35.4898 10.0254 35.6938 10.1652 35.8337C10.271 35.9396 10.4151 35.9983 10.5626 35.9983C10.6078 35.9983 10.6539 35.9927 10.6989 35.9813L17.0633 34.3938C17.1625 34.369 17.2526 34.3172 17.3246 34.2452L31.6314 19.9246L26.0564 14.3438Z",
    fill: "#6498D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.1758 12.3928L33.5834 10.7987C32.5191 9.73326 30.6641 9.73429 29.601 10.7987L27.6504 12.7514L33.2252 18.332L35.1758 16.3793C35.7075 15.8473 36.0003 15.1392 36.0003 14.3862C36.0003 13.6331 35.7075 12.925 35.1758 12.3928Z",
    fill: "#6498D6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEditNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_edit_new.12012533.svg";
export { ForwardRef as ReactComponent };